import { render } from "./Shoptester.vue?vue&type=template&id=740ce141"
import script from "./Shoptester.vue?vue&type=script&lang=js"
export * from "./Shoptester.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/tester.cl-planner.com/releases/62689321/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__